import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionPool } from './competition-pool'
import { competitionPoolActions } from './competition-pool.actions'
import * as fromCompetitionPool from './competition-pool.reducer'
import { CompetitionPoolService } from './competition-pool.service'

@Injectable()
export class CompetitionPoolEffects extends ResourceEffects<CompetitionPool> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionPoolService: CompetitionPoolService
  ) {
    super(
      fromCompetitionPool.FEATURE_NAME,
      competitionPoolService,
      competitionPoolActions,
      actions$
    )
  }
}
